import { MenuItem } from '@mui/base';
import { Select } from '@mui/material';
import { Stepper } from '../Buttons/Stepper';

interface VATFieldProps {
  value: number
  onChange?: (value: number) => void
}

export default function VATField({ value, onChange }: VATFieldProps) {
  function valueChange(v: number) {
    if (isNaN(v)) return
    onChange?.(v);
  }
  return (
    <div>
      <div className={'h-7 flex space-x-1'}>
        <div className={'flex'}>
          <Select
            disabled={true}
            sx={{ width: 50 }}
            style={{ padding: '0px' }}
            value="%"
            className={`select-pad-override bg-gray-100`}
          >
            <MenuItem value="%">%</MenuItem>
          </Select>
        </div>
        <Stepper
          disableSanitize={true}
          onValueChange={valueChange}
          min={0}
          value={value}
          allowDecimal={true}
        />
      </div>
    </div>
  )
}
